<template>
    <transition name="modal">
        <div class="dialog-modal-mask" style="z-index:1998;">
            <div class="small-panel" @click.stop>
                <div class="dialog-title">
                    <span v-if="editType==0" v-t="'message.title_saml_setting_create'"></span>
                    <span v-else v-t="'message.title_saml_setting_modify'"></span>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="250px" >
                        <div class="dialog-form-item">
                            <!--- 既定の階層 --->
                            <el-form-item ref="layerName" prop="layerName">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_saml_layer'"></span> <span v-if="editType==0" class="required" v-t="'message.item_required'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_saml_layer')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-input id="layerName" class="input-enable-saml" type="text" :placeholder="$t('message.place_holder_select_item')" v-model="inputForm.layerName.value" clearable @clear="InputCheckAll()">
                                    <el-button slot="append" @click="showSelectDialog(0)" icon="el-icon-more"></el-button>
                                </el-input>
                            </el-form-item>
                            <!--- 既定のグループ --->
                            <el-form-item ref="groupName" prop="groupName">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_saml_group'"></span> <span v-if="editType==0" class="required" v-t="'message.item_required'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_saml_group')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-input id="groupName" class="input-enable-saml" type="text" :placeholder="$t('message.place_holder_select_item')" v-model="inputForm.groupName.value" clearable @clear="InputCheckAll()">
                                    <el-button slot="append" @click="showSelectDialog(2)" icon="el-icon-more"></el-button>
                                </el-input>
                            </el-form-item>
                            <!--- Idp メタデータ --->
                            <el-form-item ref="idpMetaData" prop="idpMetaData">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_idp_metadata'"></span> <span v-if="editType==0" class="required" v-t="'message.item_required'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_saml_metadata')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <label for="file_upload">
                                    <img src="../../../../assets/icon_attach.svg" class="button-icon"/><span v-t="'message.action_selection'"></span>
                                    <input id="file_upload" @change="selectedFile" type="file" name="file" style="display:none"/>
                                </label>
                                <div v-if="showFileName">
                                    <span v-if="inputForm.idpMetaData.uploadFile == null" class='selected-filename' style="opacity: 0.6" v-t="'message.place_holder_select_file'"></span>
                                    <span v-else class='selected-filename'>{{ inputForm.idpMetaData.uploadFile.name}}</span>
                                </div>
                            </el-form-item>
                            <div v-if="showLicenseSetting()">
                                <el-form-item style="text-align:right">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_saml_enable_autoextend_license'"></span>
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" style="text-align:left" v-html="$t('message.hint_saml_enable_autoextend_license')"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </div>
                                    <el-switch v-model="inputForm.autoExtendLicense.value" active-color="#5171cb" @change="handleChangeAutoExtend()"></el-switch>
                                </el-form-item>
                                <!--- 追加可能な最大ライセンス数 --->
                                <el-form-item ref="maxLicenseCount" prop="maxLicenseCount">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_saml_max_license'"></span>
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" style="text-align:left" v-html="$t('message.hint_saml_autoextend_license')"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </div>
                                    <table>
                                    <tr>
                                        <el-checkbox v-model="inputForm.unlimitedLicense.value" :disabled="!inputForm.autoExtendLicense.value" @change="handleCheckUnlimitedLicense()"/><span v-t="'message.item_saml_autoextend_infinite_option'"></span>
                                    </tr>
                                    <tr>
                                        <el-input-number class="input-enable-saml" v-model="inputForm.maxLicenseCount.value" :min="currentMax" :disabled="!inputForm.autoExtendLicense.value || inputForm.unlimitedLicense.value"></el-input>
                                    </tr>
                                    </table>
                                </el-form-item>
                            </div>
                            <p class="beside-line" v-t="'message.info_idp_mapping'"></p>
                            <!--- ユーザー表示名 --->
                            <el-form-item ref="displayName" prop="displayName">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_userDisplayName'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_saml_attribute', { name: getAttributeName('displayName') })"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-input id="displayName" class="input-enable-saml" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="inputCheckAll()">
                                </el-input>
                            </el-form-item>
                            <!--- 部署名 --->
                            <el-form-item ref="departmentName" prop="departmentName">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_tenant_department'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_saml_attribute', { name: getAttributeName('departmentName') })"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-input id="departmentName" class="input-enable-saml" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.departmentName.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="inputCheckAll()">
                                </el-input>
                            </el-form-item>
                            <!--- 役職名 --->
                            <el-form-item ref="jobTitle" prop="jobTitle">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_job_title'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_saml_attribute', { name: getAttributeName('jobTitle') })"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-input id="jobTitle" class="input-enable-saml" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.jobTitle.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="inputCheckAll()">
                                </el-input>
                            </el-form-item>
                            <!--- 電話番号 --->
                            <el-form-item ref="phoneNumber" prop="phoneNumber">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_tenant_phone'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_saml_attribute', { name: getAttributeName('phoneNumber')})"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-input id="phoneNumber" class="input-enable-saml" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.phoneNumber.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="inputCheckAll()">
                                </el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="$emit('save',inputForm)" :disabled="this.disableButton" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import characterCheck from '../../../charactercheck.js';
import commonUtil from '../../../commonutil.js';
import commonValidate from '../../../common-validate.js';
import constants from '../../../constants.js';
import server from "../../../ServerApi.js";

export default {
    data() {
        return {
            currentMax: null,
            showFileName: true,
            disableButton: true,
            inputTypeOfPassword: "password",
            passwordShowHideButton: "SHOW",
        };
    },
    created: function() {
        this.setButtonStatus();
    },
    mounted: function() {
        // tabIndex of tooltip was always set to 0 (Should set -1 to skip focus)
        for (let element of document.getElementsByClassName('icon-help')) {
            element.setAttribute("tabIndex", "-1");
        }
    },
    methods: {
        selectedFile: function(e) {
            e.preventDefault();
            let files = e.target.files;
            this.inputForm.idpMetaData.uploadFile = files[0];
            this.inputForm.idpMetaData.valid = true;
            this.reDrawFileName();
            this.setButtonStatus();
        },
        showSelectDialog(objectType) {
            this.$emit('showDialog', objectType, this.inputForm);
        },
        setButtonStatus: function() {
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.inputForm[eventTargetId].valid = true;
                this.$refs[eventTargetId].clearValidate();
            } else {
                this.inputForm[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        handleChangeAutoExtend() {
            if (!this.inputForm.autoExtendLicense.value) {
                this.inputForm.maxLicenseCount.value = this.currentMax;
                this.inputForm.unlimitedLicense.value = false;
            }
        },
        handleCheckUnlimitedLicense() {
            if (this.inputForm.unlimitedLicense.value) {
                this.inputForm.maxLicenseCount.value = this.currentMax;
            }
        },
        inputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        reDrawFileName() {
            this.showFileName = false;
            this.$nextTick(() => {
                 this.showFileName = true
            })
        },
        getAttributeName(attributeName) {
            switch(attributeName) {
                case "displayName":
                    return commonUtil.getMessageText(this.$i18n,"item_userDisplayName");
                    break;
                case "departmentName":
                    return commonUtil.getMessageText(this.$i18n,"item_tenant_department");
                    break;
                case "jobTitle":
                    return commonUtil.getMessageText(this.$i18n,"item_job_title");
                    break;
                case "phoneNumber":
                    return commonUtil.getMessageText(this.$i18n,"item_tenant_phone");
                    break;
            }
        },
        showLicenseSetting() {
            return this.currentMax != null &&
                this.appData.onlinePurchase &&
                this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY;
        }
    },
    props: ['appData', 'inputForm' , 'editType' , 'attachInfo' , 'currentMax']
}
</script scoped>
<style scoped>
label.el-checkbox {
    margin-right: 5px;
    border: none;
    background-color: transparent;
}
label {
    font-size: 14px;
    color: #333B48;
    background-color: #f6f6f6;
    padding: 6px;
    border-radius: 4px;
    border: solid 1px;
    line-height: 33px;
    border-color: #dcdfe6;
    cursor: pointer;
}
button.el-button.el-button--default {
    padding: 12px;
}
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 270px;
    top: 2px;
    font-size: 10px;
    z-index: 10;
    color: #848991;
}
</style>
